import { render } from "./viewCheck.vue?vue&type=template&id=13a2c045&scoped=true"
import script from "./viewCheck.vue?vue&type=script&lang=js"
export * from "./viewCheck.vue?vue&type=script&lang=js"

import "./viewCheck.vue?vue&type=style&index=0&id=13a2c045&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a2c045"]])

export default __exports__